import React, { Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";
import ReporteDeVisitas from "../../../views/experienciaAlCliente/ReporteDeVisitas/ReporteDeVisitas";
import AdministracionSemaforo from "../../../views/experienciaAlCliente/AdministracionSemaforo/AdministracionSemaforo";


const ExperienciaAlCliente = () => {
    return (
        <Suspense fallback={<>Cargando...</>}>
            <Routes>
                <Route path="experiencia-cliente/reporte-visitas" element={<ReporteDeVisitas />} />
                <Route path="experiencia-cliente/semaforo" element={<AdministracionSemaforo />} />
            </Routes>
        </Suspense>
    );
};

export default ExperienciaAlCliente;
